import React from 'react';
import { withRouter, Link } from 'react-router-dom';
import ReactTooltip from 'react-tooltip';
import ReactHelmet from 'react-helmet';

import ContentLayout from 'component/page/content';
import API, {handleError} from 'utils/xhr';
import {LoaderRipple} from 'component/loader';

import {BuilderJS, PlayerJS, TriggerJS} from 'component/reuse/js_code';
import {InstructionsPara} from 'component/reuse/instruction';
import Track from 'utils/tracker';
import SiteAddForm from 'component/reuse/site_add_form';
import { ShowLink, ShowSup } from 'component/reuse/show';


var options = { year: 'numeric', month: 'long', day: 'numeric' }

class Page extends React.Component {

  constructor(props){
    super(props);
    const {site_xid, show_xid} = props.match.params;
    this.state = {
      list_sites: null,
      picked_site_xid: site_xid || null,
      picked_show_xid: show_xid || null,
      list_site_shows: null,
      fetching_data: {
        list_sites: false,
        list_shows: false,
      },
    }
  }

  componentDidMount(){

    var state = this.state;
    state.fetching_data.list_sites = true;
    this.setState(state);

    const url = '/sites';
    API.get(url).then(response => {
      var state = this.state;
      state.list_sites = response.data.data;
      state.fetching_data.list_sites = false;
      this.setState(state);

    }, (error) => {

      handleError(error, this.props.history, window.location.pathname);
    });

    if (this.state.picked_site_xid !== null){
      this.populateSiteShowList(this.state.picked_site_xid);
    }
  }

  pickSite(e){
    const site_xid = e.currentTarget.dataset.site_xid;
    Track.site('list_sites', site_xid);
    this.populateSiteShowList(site_xid);
  }

  pickShow(e){
    const show_xid = e.currentTarget.dataset.show_xid;
    Track.site('list_shows', show_xid);

    const state = this.state;
    state.picked_show_xid = show_xid;
    this.setState(state);
  }

  populateSiteShowList(site_xid){
    var state = this.state;
    state.fetching_data.list_shows = true;
    this.setState(state);

    const url = '/sites/' + site_xid + '/shows';
    API.get(url).then(response =>{
      const state = this.state;
      state.picked_site_xid = site_xid;
      state.list_site_shows = response.data.data;
      state.fetching_data.list_shows = false;
      this.setState(state);

    },(error) =>{
      handleError(error, this.props.history);
    })
  }

  render (){

    return (
      <ContentLayout id="list-site-page">
        
        <ReactHelmet>
          <script src="https://divshow.bytebeacon.com/sdk/0.0.16/divshow.min.js?show_id=yyhujgkki,v8cvi59y3"></script>

          {/* <script src="http://localhost:3000/sdk/0.0.16/divshow_builder.js?api_key=vzvlgdz7y8"></script> */}
          {/* <script src="http://localhost:3000/sdk/0.0.16/divshow.js?show_id=ba3i2ly6b"></script> */}
        </ReactHelmet>

        <SiteAddForm />

        <div className="row mt-3 ">
          <div className="col-md-6">
            <SiteList 
              list_sites={this.state.list_sites}
              picked_site_xid={this.state.picked_site_xid}
              fetching_data={this.state.fetching_data.list_sites}
              pickSite={this.pickSite.bind(this)}
              // showXID={"yyhujgkki"}
              showXID={"ba3i2ly6b"}
            />
          </div>
          <div className="col-md-6">
            <ShowList 
              site_xid={this.state.picked_site_xid}
              picked_show_xid={this.state.picked_show_xid}
              list_site_shows={this.state.list_site_shows}
              fetching_data={this.state.fetching_data.list_shows}
              pickShow={this.pickShow.bind(this)}
              showXID={"v8cvi59y3"}
              // showXID={"exeg9qloq"}
            />
          </div>
        </div>
      </ContentLayout>
    )
  }
}

function ShowList(props){

  if (props.fetching_data){
    return (<LoaderRipple fetching_data={true} />);
  }

  const list_site_shows = props.list_site_shows;
  const picked_show_xid = props.picked_show_xid;
  const pickShow = props.pickShow;

  if (list_site_shows === null ) { 
    return '';
  }
  if (Object.keys(list_site_shows).length === 0 ) { 
    return (
      <div className="">
        <h4>No shows recorded yet! </h4>
        <InstructionsPara/>
      </div>
    )
  }

  list_site_shows.sort(function(a, b){if(a.inserted_at < b.inserted_at) return 1; if(a.inserted_at > b.inserted_at) return -1; return 0;});

  return (
    <div className="">

      {list_site_shows.map(function(show, i){
        return (
          (show.xid === picked_show_xid)? (
            <div className=""  key={"site_"+show.xid}>
              <ShowListItemFullDisplay show={show} showXID={props.showXID} />
              <hr className="highlight-white-4 black-bb-1-1 m-4"/>
            </div>
          ): ('')
        )
      })}

      <h3 className="family-h3 my-3">All shows:</h3>
      <ul className="list-group" style={{ listStyleType: "none" }}>
        
      {list_site_shows.map(function(show, i){
        return (
          (show.xid === picked_show_xid)? (
            <li className={"my-1 "} key={"site_"+show.xid}>
              <ShowListItemFullDisplay show={show} showXID={props.showXID} />
            </li>
          ): (
            <li className={"list-group-item my-1 "} key={"site_"+show.xid}>
              <Link to={"/sites/" + props.site_xid + "/shows/" + show.xid} onClick={pickShow} data-show_xid={show.xid}>
                <h3 className=" text-black-4">Show: {(show.show_name)? show.show_name: show.xid}</h3>
                <div className="text-muted my-1"><small>Show created on: <b>{new Date(show.inserted_at).toLocaleString('en-US', options)}</b></small></div>
              </Link>
            </li>
          )
        )
      })}

      </ul>
    </div>
  )
}

function ShowListItemFullDisplay(props){
  const show = props.show;
  const showXID = props.showXID;

  return (
    <div className={"list-group-item  text-black-2 my-1 box-shadow"} key={"site_"+show.xid}>
      <Link to={"/shows/" + show.xid} className="text-info" >
        {(show.show_name)? (<h5>{show.show_name}</h5>): (<h5>Show: {show.xid}<small className="text-muted">{" - Click to set a show name"}</small></h5>)}
      </Link>

      <div className="my-3">
        <p>Show ID: <span className="uppercase  rounded highlight-dark-2 px-2"> {show.xid}</span> <ShowSup show_xid={showXID} type={"small"} text={"?"} tip="Click to see how to add the show to your site" btn_class=" strong text-info mx-1" /></p>
      </div>

      <div className="my-2">

        <div className="my-2">
          <PlayerJS show_xid={show.xid}/>
        </div>

        <div className="my-2">
          <p className="">To play the show, call <span className="text-muted small">window.DivShow.Play("{show.xid}")</span> from an element that should trigger the show.</p>
          <TriggerJS show_xid={show.xid} />
        </div>

        <div className="">
          <Link to={"/shows/" + show.xid} data-tip="View / Edit details" className="m-3" ><span className="text-info far fa-edit fa-2x"></span></Link>
          <Link to={"/analytics/shows/" + show.xid} data-tip="View Analytics" className="m-3" ><span className="text-info far fa-chart-bar fa-2x"></span></Link>
        </div>

        <hr className="highlight-white-4 black-bb-1-1"/>

        <div className="d-flex justify-content-between">
          {/* <InstructionsPara short={true} showXID={showXID}/> */}
          <span className="m-0 my-lg-0 text-muted">
            <div className="my-1"><small>Show created on: <b>{new Date(show.inserted_at).toLocaleString('en-US', options)}</b></small></div>
          </span>
        </div>

      </div>
      
    </div>
  )
}

function SiteList(props) {
  const list_sites = props.list_sites;
  const picked_site_xid = props.picked_site_xid;
  const pickSite = props.pickSite;

  if (props.fetching_data){
    return (<LoaderRipple fetching_data={true} />);
  }

  if (list_sites === null || list_sites.length === 0 || Object.entries(list_sites).length === 0){
    return (<div className="alert alert-info"><span className="strong">No sites found!</span> Add a site to get your API key and generate DivShow presentations!</div>)
  }

  list_sites.sort(function(a, b){if(a.inserted_at < b.inserted_at) return 1; if(a.inserted_at > b.inserted_at) return -1; return 0;});

  return (
    <div>
      <ReactTooltip effect="solid" html={true} />

      <ul className="list-group" style={{ listStyleType: "none" }}>
        {list_sites.map(function(site, i){
          const inserted_at = (site.inserted_at === null)? null: new Date(site.inserted_at).toLocaleString('en-US', options);
          const bg = (site.xid === picked_site_xid)? ' ': ' ';
          const card_effect = (site.xid === picked_site_xid)? ' box-shadow': '';
          const text_colour = (site.xid === picked_site_xid)? ' text-quaternary ': ' text-black-5 ';
          return (
            <li className={"list-group-item my-1 " + card_effect} key={"site_"+site.xid}>
              <div className="text-black">
                <Link className={""} to={'/sites/' + site.xid} onClick={pickSite} data-site_xid={site.xid} >
                  <div className={"d-flex justify-content-between text-black-2"}>
                    <h5 className={" " + text_colour}>Site: {site.site_name}</h5>
                    <span className="m-0 my-lg-0"><i className={" fa fa-fw fa-2x fa-angle-double-right" + text_colour}></i></span>
                  </div>
                </Link>

                <div className={"" + bg}>
                  {(site.xid === picked_site_xid)? (
                    <div className="text-black-2">
                      <div className={"my-3"}>
                        <p>API key: <span className="uppercase rounded highlight-dark-2 px-2"> {site.api_key}</span> <ShowSup show_xid={props.showXID} type={"small"} text={"?"} tip="Click to see how to record your show" btn_class=" strong text-quaternary mx-1" /></p>
                      </div>

                      <div className="my-2">
                        <BuilderJS api_key={site.api_key} />
                      </div>

                      <div className="">
                        <Link to={"/analytics/sites/" + site.xid} data-tip="View Analytics" className="m-3" ><span className="text-quaternary far fa-chart-bar fa-2x"></span></Link>
                      </div>

                      <hr className="highlight-white-4 black-bb-1-1"/>

                    </div>
                  ): ('')}

                  <div className="d-flex justify-content-between">
                    {/* <InstructionsPara showXID={props.showXID}/> */}
                    <span className="m-0 my-lg-0 text-muted">
                      <div className="my-1"><small>Site added on: <b>{inserted_at}</b></small></div>
                    </span>
                  </div>
                </div>

              </div>
            </li>
          )
        })}
      </ul>

    </div>
  )  
}

export default withRouter(Page);
